/** Mirrors apiserver spec.driver.TimeSlotDto — a single availability block (HH:mm strings). */
export interface TimeSlot {
  id: number | null;
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
}

/** Mirrors apiserver spec.driver.DayScheduleDto — one day's on/off flag + its time blocks. */
export interface DaySchedule {
  dayOfWeek: string; // MONDAY … SUNDAY
  isActive: boolean;
  timeSlots: TimeSlot[];
}

/** Mirrors spec.driver.ScheduleResponse — the per-driver weekly schedule (always 7 days). */
export interface ScheduleResponse {
  schedules: DaySchedule[];
}

/** Mirrors spec.response.admin.AdminDriverScheduleResponse — one row of the all-drivers grid. */
export interface AdminDriverSchedule {
  driverProfileId: number;
  userId: number | null;
  name: string | null;
  email: string | null;
  available: boolean | null;
  schedules: DaySchedule[];
}

export const DAY_ORDER = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
] as const;

export const DAY_ABBR: Record<string, string> = {
  MONDAY: 'Mon',
  TUESDAY: 'Tue',
  WEDNESDAY: 'Wed',
  THURSDAY: 'Thu',
  FRIDAY: 'Fri',
  SATURDAY: 'Sat',
  SUNDAY: 'Sun'
};
